<div>
  <h1 class="main-title">
    <div class="circle circle-primary">
      <img src="assets/icons/info-icon.svg" alt="">
    </div>
    Gráficos y Estadísticas
  </h1>
  <div class="flex justify-between items-center mb-2">
    <h2 class="main-subtitle">Línea de tiempo</h2>
    <a routerLink="/container-report" class="button button-outlined-primary">
      <i class="fa-solid fa-chevron-left" alt=""></i> Volver
    </a>
  </div>

  <div class="single-page-content">
    <h3 class="text-primary-700 text-xl">{{ header?.container?.containerType?.name }} #{{ header?.container?.nroSerie }}</h3>

    <table class="table table-report w-full mb-4 hidden md:table">
      <tr>
        <th>Propietario:</th>
        <td>{{ header?.container?.client?.razonSocial }}</td>
        <th>Cliente:</th>
        <td>{{ header?.container?.client?.razonSocial }}</td>
      </tr>
      <tr>
        <th>Estado:</th>
        <td>{{ header?.status }}</td>
        <th>Fecha de mantención:</th>
        <td>{{ header?.ultimaMantencion }}</td>
      </tr>
    </table>

    <table class="table table-report w-full mb-4 md:hidden">
      <tr>
        <th>Propietario:</th>
        <td>{{ header?.container?.client?.razonSocial }}</td>
      </tr>
      <tr>
        <th>Cliente:</th>
        <td>{{ header?.container?.client?.razonSocial }}</td>
      </tr>
      <tr>
        <th>Estado:</th>
        <td>{{ header?.status }}</td>
      </tr>
      <tr>
        <th>Fecha de mantención:</th>
        <td>{{ header?.ultimaMantencion }}</td>
      </tr>
    </table>

    <ngx-timeline [events]="events"></ngx-timeline>
  </div>
</div>
